function updateViewportDimensions() {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;
  return {
    width: x,
    height: y,
  };
}

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout(timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

// setting the viewport width
var viewport = updateViewportDimensions();
var $header = jQuery(".header"),
  header_height = $header.outerHeight(),
  $window = jQuery(window),
  window_height = $window.height(),
  window_width = $window.width(),
  $document = jQuery(document),
  doc_top = $document.scrollTop(),
  doc_btm = window_height,
  last_top = doc_top,
  cur_top = 0,
  cur_pos = window_height - header_height;

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;

var windowWidth = jQuery(window).width();
jQuery(window).resize(function () {
  waitForFinalEvent(initializeScreen, timeToWaitForLast, "initializeScreen");
});

var fix_menus = function () {
  var viewport = updateViewportDimensions();
  if (viewport.width < 1024) {
    // on load add arrows as appropriate
    jQuery(".menu")
      .find("li.page_item_has_children > a")
      .append('<i class="fa fa-angle-right"></i>');
    // then, change those that should be open to downs.
    jQuery(".menu")
      .find("li.current_page_parent > a .fa, li.current_page_ancestor > a .fa")
      .removeClass("fa-angle-right")
      .addClass("fa-angle-down");

    jQuery(nonclickablepageids).each(function (i, val) {
      jQuery("li.page-item-" + val + " > a")
        .addClass("nolink")
        .addClass("childclick");
    });
  }
};

var fix_sidebar = function () {
  var viewport = updateViewportDimensions();

  // on archive pages, show the category children. page-template-page-blog
  if (
    jQuery("body").hasClass("archive") ||
    jQuery("body").hasClass("single") ||
    jQuery("body").hasClass("page-template-page-blog")
  ) {
    if (
      !jQuery("body").hasClass("post-type-archive-tribe_events") &&
      !jQuery("body").hasClass("single-tribe_events")
    )
      jQuery("li.page-item-169")
        .addClass("current_page_parent")
        .find("ul.children")
        .css("display", "block");
  }
  if (jQuery("body").hasClass("page-id-166")) {
    jQuery("li.page-item-166")
      .addClass("current_page_parent")
      .find("> ul.children")
      .css("display", "block");
  }

  // on load add arrows as appropriate
  jQuery(".sidenav")
    .find("li.page_item_has_children > a")
    .append('<i class="fa fa-angle-right"></i>');

  // then, change those that should be open to downs.
  jQuery(".sidenav")
    .find("li.current_page_parent > a .fa, li.current_page_ancestor > a .fa")
    .removeClass("fa-angle-right")
    .addClass("fa-angle-down");

  jQuery(nonclickablepageids).each(function (i, val) {
    jQuery(".sidenav li.page-item-" + val + " > a")
      .addClass("nolink")
      .addClass("childclick");
  });

  jQuery(".sidenav")
    .find("li.current_page_ancestor > ul li a")
    .each(function (index, item) {
      var this_li_a = jQuery(item);
      if (
        this_li_a.html().indexOf("Adults") != -1 ||
        this_li_a.html().indexOf("Children") != -1
      ) {
        // if (this_li_a.hasClass('nolink')) {
        jQuery(this).closest("li").find(".children").slideDown(200);
        jQuery(this).closest("li").find(".fa-angle-right").hide();
      }
    });
};

// clean up after resizing window.
var initializeScreen = function () {
  if (jQuery(window).width() != windowWidth) {
    // Update the window width for next time
    windowWidth = jQuery(window).width();
    viewport = updateViewportDimensions();
    jQuery(".slide").matchHeight();
    if (viewport.width > 768) {
      jQuery(".floatblock").matchHeight();
      jQuery(".single-service").matchHeight();
    }
    if (viewport.width >= 1024) {
      jQuery(".menu_section").matchHeight();
    }
  }
};

/*
 * Put all your regular jQuery in here.
 */
jQuery(document).ready(function ($) {
  var viewport = updateViewportDimensions();
  var $window = $(window);

  /**
   * Resize image slides to fill window height
   */
  function resizeHandler() {
    var scroll = $window.scrollTop();
    viewport = updateViewportDimensions();
    if (parseInt(scroll) > 300) {
      if (viewport.width > 1023 || $(".navigation").css("display") != "block") {
        $(".uparrow").show(200);
      }
    } else {
      $(".uparrow").hide(200);
    }
  }

  resizeHandler();
  $(window).scroll(function () {
    waitForFinalEvent(resizeHandler, timeToWaitForLast, "mainresize");
  });

  var menu = jQuery(".navigation");
  $(".morebars").click(function () {
    if (menu.css("display") == "block") {
      menu.fadeOut(200);
    } else {
      $(".uparrow").hide();
      menu.fadeIn(200);
    }
  });

  $(".mainheader .close").click(function () {
    $(".tools .search").show();
    $(".tools .close").hide();
    $(".searchwrapper").hide();
    $(".searchwrapper").addClass("hidden");
  });
  $(".mainheader .search").click(function () {
    $(".tools .search").hide();
    $(".tools .close").show();
    $(".searchwrapper").show();
    $(".searchwrapper").removeClass("hidden");
  });

  $(".navigation .search").click(function () {
    $(".searchwrapper").toggle();
    $(".searchwrapper").toggleClass("hidden");
    $searchIcon = $(this);
    if ($searchIcon.hasClass("closeme")) {
      $(".tools .search").show();
      $(".tools .close").hide();
      $searchIcon.removeClass("closeme");
    } else {
      $(".tools .search").hide();
      $(".tools .close").show();
      $searchIcon.addClass("closeme");
    }
  });

  $(".homeslider.mobile").slick({
    lazyLoad: "ondemand",
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
    cssEase: "linear",
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    /*easing: 'easeInOutQuad',
        useTransform: true,*/
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          dots: false,
        },
      },
    ],
  });
  var fixed = false;
  $(".homeslider.mobile").on(
    "beforeChange",
    function (event, slick, direction) {
      if (!fixed) {
        $(".slide").matchHeight();
        fixed = true;
      }
    }
  );

  $(".quote_slider").slick({
    lazyLoad: "ondemand",
    dots: true,
    infinite: true,
    speed: 800,
    fade: true,
    cssEase: "linear",
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    /*easing: 'easeInOutQuad',
        useTransform: true,*/
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          dots: false,
        },
      },
    ],
  });

  fix_menus();

  // Consider putting in navigation setting, i.e. pre-opening the items so they're ready.
  $(".menu .fa-angle-right, .menu .fa-angle-down").click(function (e) {
    // open menus as needed.
    if ($(this).hasClass("fa-angle-right")) {
      $(this).closest("li").find("> .children").fadeIn(200);
      $(this).removeClass("fa-angle-right").addClass("fa-angle-down");
    } else {
      $(this).closest("li").find("> .children").fadeOut();
      $(this).removeClass("fa-angle-down").addClass("fa-angle-right");
      $(this).find(".children").show();
    }
    e.preventDefault();
  });

  fix_sidebar();
  // Consider putting in navigation setting, i.e. pre-opening the items so they're ready.
  $(".sidebar .fa-angle-right, .sidebar .fa-angle-down").click(function (e) {
    // open menus as needed.
    if ($(this).hasClass("fa-angle-right")) {
      $(this).closest("li").find("> .children").slideDown(200);
      $(this).removeClass("fa-angle-right").addClass("fa-angle-down");
      // figure out if this item has immediate children with no click. If so, open all of it.
      $(this)
        .closest("li")
        .find("> .children > li > a")
        .each(function (index, item) {
          var this_li_a = $(item);
          if (
            this_li_a.html().indexOf("Adults") != -1 ||
            this_li_a.html().indexOf("Children") != -1
          ) {
            // if (this_li_a.hasClass('nolink')) {
            $(this).closest("li").find(".children").slideDown(200);
            $(this).closest("li").find(".fa-angle-right").hide();
          }
        });
    } else {
      $(this).closest("li").find("> .children").slideUp(200);
      $(this).removeClass("fa-angle-down").addClass("fa-angle-right");
      $(this).find(".submenu").show();
    }
    e.preventDefault();
  });

  if (viewport.width >= 768) {
    jQuery(".floatblock").matchHeight();
    jQuery(".single-service").matchHeight();
  }
  if (viewport.width >= 1024) {
    jQuery(".menu_section").matchHeight();
  }

  jQuery("#menu-main-menu .page_item").click(function (e) {
    viewport = updateViewportDimensions();
    if (viewport.width >= 1024) {
      var $thismenu = jQuery(this);
      if ($thismenu.hasClass("search")) {
        return;
      } else if ($thismenu.hasClass("active")) {
        e.preventDefault();
        $thismenu.removeClass("active");
        jQuery(".menu_section").slideUp(200);
      } else {
        jQuery(".page_item").removeClass("active");
        $thismenu.addClass("active");
        var classes = $thismenu.attr("class").split(" ");
        var menu_section_slug = classes[1];
        // close existing
        jQuery(".menu_section").slideUp(200);
        // open this!
        if (
          menu_section_slug == "how-we-can-help" ||
          jQuery(".menu_section.mega-" + menu_section_slug).length > 0
        ) {
          jQuery(".menu_section.mega-" + menu_section_slug).slideDown(200);
          jQuery(".menu_section h3").matchHeight();
          jQuery(".menu_section").matchHeight();
        }
        e.preventDefault();
        return false;
      }
    }
  });

  $("body").click(function () {
    jQuery(".menu_section").hide();
  });

  $(".bio").matchHeight();

  $(".uparrow").click(function (e) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    e.preventDefault();
  });

  // Seriously. Add placeholders for shitty constant contact embed form after the page has loaded.
  var setCCPlaceholders = function () {
    $("#email_address_0").attr("placeholder", "Email");
    $("#first_name_0").attr("placeholder", "Name");
    $("#email_address_1").attr("placeholder", "Email");
    $("#first_name_1").attr("placeholder", "Name");
  };
  setInterval(setCCPlaceholders, 500);

  // Popup block auto-open + close handlers
  var $popup = $(".popup-block");
  if ($popup.length) {
    var openPopup = function () {
      $popup.removeClass("is-closing").addClass("is-open").attr("aria-hidden", "false");
      $("body").addClass("popup-open");
    };
    var closePopup = function () {
      $popup.addClass("is-closing");
      window.setTimeout(function () {
        $popup.removeClass("is-open is-closing").attr("aria-hidden", "true");
        $("body").removeClass("popup-open");
      }, 250);
    };

    window.setTimeout(openPopup, 2000);

    $popup.on("click", ".popup-block__overlay, .popup-block__close", function (e) {
      e.preventDefault();
      closePopup();
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape") {
        closePopup();
      }
    });
  }

  svg4everybody();

  // flexibility(jQuery('.section_header .innerWrapper'));
});

/* end of as page load scripts */
